import { z } from 'zod';
import { programSchema } from './team.ts';

export const eventSchema = z.object({
  id: z.uuid(),
  eventCode: z.string(),
  robotEventsEventId: z.string().nullable(),
  name: z.string(),
  program: programSchema,
  season: z.string(),
  startDate: z.iso.datetime(),
  endDate: z.iso.datetime(),
  venue: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  country: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type Event = z.infer<typeof eventSchema>;

export const eventTeamSchema = z.object({
  id: z.uuid(),
  eventId: z.uuid(),
  teamId: z.uuid(),
  divisionName: z.string().nullable(),
  divisionSlug: z.string().nullable(),
  registrationStatus: z.string().nullable(),
  qualificationStatus: z.string().nullable(),
  skillsRank: z.number().int().nullable(),
  awards: z.array(z.string()),
  lastSyncedAt: z.iso.datetime().nullable(),
});
export type EventTeam = z.infer<typeof eventTeamSchema>;

export const divisionSchema = z.object({
  divisionSlug: z.string(),
  divisionName: z.string(),
  eventCode: z.string(),
  eventName: z.string(),
  teamCount: z.number().int(),
});
export type Division = z.infer<typeof divisionSchema>;

export const countryRollupSchema = z.object({
  countrySlug: z.string(),
  country: z.string(),
  teamCount: z.number().int(),
  cityCount: z.number().int(),
  programBreakdown: z.record(programSchema, z.number().int()),
});
export type CountryRollup = z.infer<typeof countryRollupSchema>;

export const cityRollupSchema = z.object({
  citySlug: z.string(),
  city: z.string(),
  region: z.string().nullable(),
  country: z.string(),
  countrySlug: z.string(),
  lat: z.number().nullable(),
  lon: z.number().nullable(),
  teamCount: z.number().int(),
  programBreakdown: z.record(programSchema, z.number().int()),
});
export type CityRollup = z.infer<typeof cityRollupSchema>;
